import { createSession, type ClientSession } from '../features/account/web/session';
import { clientConfig } from '../shared/web/config/client-config';

/**
 * The one session this build holds.
 *
 * Composition, not feature logic: the project URL and publishable key from
 * `clientConfig`, handed to the account slice's session module. Built lazily
 * on first call rather than at module scope, because the root route's module
 * graph is rendered in Node to produce `index.html` (see `README.md`), and
 * the library reaches for `window` and its storage when constructed.
 *
 * One instance for the life of the page: the library persists under one key
 * and holds one refresh ticker, and a second instance would race it.
 */
let session: ClientSession | null = null;

export function appSession(): ClientSession {
  session ??= createSession({
    url: clientConfig.supabaseUrl,
    publishableKey: clientConfig.supabasePublishableKey,
  });
  return session;
}
